import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `fn bigger(a: usize, b: usize) -> usize {
    // TODO: Complete this function to return the bigger number!
    // Do not use:
    // - another function call
    // - additional variables
}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
// Don't mind this for now :)
mod tests {
    use super::bigger;

    #[test]
    fn ten_is_bigger_than_eight() {
        assert(10_usize == bigger(10_usize, 8_usize), '10 bigger than 8');
    }

    #[test]
    fn fortytwo_is_bigger_than_thirtytwo() {
        assert(42_usize == bigger(32_usize, 42_usize), '42 bigger than 32');
    }
}`;
